// Dev-mode mock context.
//
// Enabled by setting VITE_DEV_MOCK_CONTEXT=true in the app environment.
// Never enabled in production. Values are the standing sample (Sarah
// Mitchell) already documented in memory. No fabricated identities.

import type { HubSpotContext } from './hubspotContext.js';
import type { HubSpotSession } from './hubspot-handshake.js';

// Sarah Mitchell is the standing sample customer, used across the
// walkthrough decks and this scaffold. Sample-only. Never a real record.
export const SAMPLE_CONTACT_ID = 'sample-contact-sarah-mitchell';
export const SAMPLE_USER_ID = 'sample-rep-user';
export const SAMPLE_USER_EMAIL = 'sample-rep@100xequine.example';
export const SAMPLE_PORTAL_ID = 245546374;

// Bearer for local dev only. The API server rejects it unless the local
// deploy is bootstrapped with the same value in RUNTIME_API_TOKEN. Never
// commit a real token, and never ship this file's constants to production.
export const SAMPLE_DEV_TOKEN = 'dev-mock-token-do-not-ship-to-production';

export function getMockHubSpotContext(): HubSpotContext | null {
  return {
    userId: SAMPLE_USER_ID,
    userEmail: SAMPLE_USER_EMAIL,
    portalId: SAMPLE_PORTAL_ID,
    objectId: SAMPLE_CONTACT_ID,
    contextToken: SAMPLE_DEV_TOKEN,
    receivedAt: Date.now(),
  };
}

// True when the active session is the local dev mock. Used by boundary +
// chrome helpers to switch to fixture rendering without round-tripping the
// api-server. Guards against the fixture ever being rendered against a
// production token (userId or email mismatch returns false).
export function isDevMockSession(
  session: HubSpotSession | HubSpotContext | null | undefined,
): boolean {
  if (!session) return false;
  const userId = 'userId' in session ? session.userId : null;
  const email = 'email' in session
    ? session.email
    : 'userEmail' in session
      ? session.userEmail
      : null;
  const token = 'token' in session
    ? session.token
    : 'contextToken' in session
      ? session.contextToken
      : null;
  return (
    userId === SAMPLE_USER_ID &&
    email === SAMPLE_USER_EMAIL &&
    token === SAMPLE_DEV_TOKEN
  );
}
